// extracted by mini-css-extract-plugin
export default {"daytimeslots":"DayTimeSlots_daytimeslots__scTRh"};